<section id="js-map-print" class="h-100 w-100">
  <ng-container *ngIf="googleMapLoader.isApiLoaded | async">
    <google-map [options]="mapOptions" (mapRightclick)="mapRightClick($event)">

      <map-info-window class="coordinates-info-window" [position]="clickedCoordinates" #coordinatesInfoWindow="mapInfoWindow">
        <div class="coordinates d-flex align-items-center p-3">
          <div>
            <p class="coordinate mb-0">Lat: <span class="value">{{ clickedCoordinates?.lat() | number:'1.2-5' }}</span></p>
            <p class="coordinate mb-0">Long: <span class="value">{{ clickedCoordinates?.lng() | number:'1.2-5' }}</span></p>
          </div>
          <i class="fas fa-copy" (click)="copyToClipboard()"></i>
        </div>
      </map-info-window>

      <map-marker *ngIf="locateOnMapMarker"
                  [options]="{ icon: locateOnMapMarker.icon, draggable: locateOnMapMarker.draggable }"
                  [position]="{ lat: locateOnMapMarker.lat, lng: locateOnMapMarker.lng }"
                  [title]="locateOnMapMarker.title"
      ></map-marker>

      <map-marker
        *ngFor="let m of markers; trackBy: trackByMarkers"
        #marker="mapMarker"
        [options]="{ icon: m.isOpen ? m.selectedIcon : m.icon, visible: m.visible, draggable: m.draggable, clickable: !isDrawingActive }"
        [position]="{ lat: m.lat, lng: m.lng }"
        [title]="m.title"
        (mapClick)="onMarkerClick(m)"
      ></map-marker>

      <map-marker *ngIf="selectedMarker"
                  [position]="{ lat: selectedMarker.lat, lng: selectedMarker.lng }"
                  [options]="{ opacity: 0 }"
                  #selectedMarkerRef="mapMarker"
                  (mapClick)="openInfoWindow(selectedMarkerRef, 'selectedMarker')">
        <!--Render the Window once, show only when clicked-->
        <map-info-window #selectedMarkerInfoWindow="mapInfoWindow" (closeclick)="closeSelectedMarker()">
            <rlst-info-window
              [propertyData]="selectedMarker.propertyData"
              [parcelId]="selectedMarker.parcelId"
              [fipsCode]="selectedMarker.fipsCode"
              [isInstanetLinkAvailable]="isInstanetLinkAvailable$ | async"
              [isReverseLinkAvailable]="isReverseLinkAvailable$ | async"
              [savedPropertyIdList]="savedPropertyIdList"
              [propertyItem]="getPropertyInformation(selectedMarker)"
              [savedProperties]="savedProperties"
              (zoomIntoProperty)="zoomToProperty(selectedMarker)"
              (closeWindow)="closeSelectedMarker()"
              (getLotDimensions)="getLotDimensions(selectedMarker)"
              (reverseLink)="getReverseLink(selectedMarker)"
              (instanetLink)="getInstanetLink(selectedMarker)"
              (openReport)="openReports(selectedMarker)"
              (viewPhotos)="showPictureViewer(selectedMarker.parcelId, selectedMarker.fipsCode, selectedMarker.propertyData)"
              (loadParcelDisclaimer)="loadParcelDisclaimer({ latitude: selectedMarker.lat, longitude: selectedMarker.lng })">
            </rlst-info-window>
        </map-info-window>
      </map-marker>

      <map-marker *ngFor="let annotation of annotations$ | async;"
                  #annotationMarker="mapMarker"
                  [position]="{ lat: annotation.lat, lng: annotation.lng }"
                  [options]="{ draggable: true, icon: 'assets/img/agm/annotation-pin.png' }"
                  (mapClick)="openInfoWindow(annotationMarker, 'annotationMarker')"
      >
        <map-info-window #annotationInfoWindow="mapInfoWindow">
            <rlst-annotation-window (deleteAnnotation)="deleteAnnotation(annotation)"></rlst-annotation-window>
        </map-info-window>
      </map-marker>

      <map-marker *ngIf="shapeIsOpen" [position]="{ lat: shapeLat, lng: shapeLong }" [options]="{ opacity: 0 }" #shapeMarker="mapMarker" (mapClick)="openInfoWindow(shapeMarker, 'shapeMarker')">
        <map-info-window *ngIf="shapeIsOpen" (closeclick)="openShape(false)" #shapeInfoWindow="mapInfoWindow">
          <rlst-shape-info-window [name]="shapeName"
                                  [radius]="shapeRadius"
                                  [area]="shapeArea"
                                  [totalArea]="totalShapesArea"
                                  [distance]="shapeDistance"
                                  [maxTotalArea]="SHAPE_MAX_AREA"
                                  [shapeType]="shapeType"
                                  (nameChange)="onNameChange($event)"
                                  (deleteShape)="deleteShape()"
                                  (submitSearch)="submitSearch()"
                                  (click)="$event.stopPropagation()">
          </rlst-shape-info-window>
        </map-info-window>
      </map-marker>

      <map-marker *ngIf="driveDirectionWindowIsOpen" [position]="{ lat: driveDirectionWindowLat, lng: driveDirectionWindowLong }" [options]="{ opacity: 0 }" #driveMarker="mapMarker" (mapClick)="openInfoWindow(driveMarker, 'driveMarker')">
        <map-info-window *ngIf="driveDirectionWindowIsOpen" (closeclick)="driveDirectionClose()" #driveInfoWindow="mapInfoWindow">
          <rlst-drive-direction-window
            [leg]="driveDirectionLeg"
            (closeWindow)="driveDirectionClose()"
            (sendEmailDriveDirection)="sendEmailDriveDirection()"
            (clearDirections)="clearDirections()">
          </rlst-drive-direction-window>
        </map-info-window>
      </map-marker>

      <map-marker *ngIf="propertyInfoMarker.isOpen" [position]="{ lat: propertyInfoMarker.lat, lng: propertyInfoMarker.lng }" [options]="{ opacity: 0 }" #propInfoMarker="mapMarker" (mapClick)="openInfoWindow(propInfoMarker, 'propInfoMarker')">
        <map-info-window (closeclick)="hideLotDimensions()" #propInfoWindow="mapInfoWindow">
            <div *ngIf="!propertyInfoMarker.taxId" class="marker-window__message">
              Information for this location is unavailable.
            </div>
            <div *ngIf="!propertyInfoMarker.provisionedProperty" class="marker-window__message">
              You have selected to view a property that is outside of your coverage area.
            </div>
            <rlst-info-window
              *ngIf="propertyInfoMarker.taxId && propertyInfoMarker.provisionedProperty"
              [propertyData]="propertyInfoMarker.propertyData"
              [parcelId]="propertyInfoMarker.parcelId"
              [fipsCode]="propertyInfoMarker.fipsCode"
              [isInstanetLinkAvailable]="isInstanetLinkAvailable$ | async"
              [isReverseLinkAvailable]="isReverseLinkAvailable$ | async"
              [savedPropertyIdList]="savedPropertyIdList"
              [propertyItem]="getPropertyInformation(propertyInfoMarker)"
              [savedProperties]="savedProperties"
              (zoomIntoProperty)="zoomToProperty(propertyInfoMarker)"
              (getLotDimensions)="getLotDimensions(propertyInfoMarker)"
              (instanetLink)="getInstanetLink(propertyInfoMarker)"
              (reverseLink)="getPropertyReverseLink(propertyInfoMarker)"
              (openReport)="openSingleReport(propertyInfoMarker)"
              (hideWindow)="hideSnazzyWindow(propertyInfoMarker)"
              (viewPhotos)="showPictureViewer(propertyInfoMarker.parcelId, propertyInfoMarker.fipsCode, propertyInfoMarker.propertyData)"
              (loadParcelDisclaimer)="loadParcelDisclaimer({ latitude: propertyInfoMarker.lat, longitude: propertyInfoMarker.lng })">
            </rlst-info-window>
        </map-info-window>
      </map-marker>
      <ng-container *ngIf="allowPointsOfInterest$ | async">
        <ng-container *ngFor="let categoryArray of fetchPointsOfInterest$ | async">
          <ng-container *ngFor="let placesArray of categoryArray | keyvalue">
            <map-marker *ngFor="let point of placesArray.value; let i = index"
                        #marker="mapMarker"
                        [options]="{ icon: createIcon(point.icon) }"
                        [position]="{ lat: point.geometry.location.lat, lng: point.geometry.location.lng }"
                        (mapClick)="openInfoWindow(marker, 'poiMarker', i + 1);"
            >
              <map-info-window>
                  <div class="marker-window__message point-of-interest">
                    <p class="name w-100">{{point.name}}</p>
                    <p class="vicinity w-100">{{point.vicinity}}</p>
                    <p class="rating m-0"><i class="fas fa-star"></i><span class="sr-only">Rating</span> {{point.rating}}
                    </p>
                  </div>
              </map-info-window>
            </map-marker>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="floodZoneMarker$ | async as floodZoneMarker">
        <map-marker *ngIf="floodZoneMarker.isOpen"
                    [position]="{ lat: floodZoneMarker.lat, lng: floodZoneMarker.lng }"
                    [options]="{ opacity: 0 }"
                    #floodMarker="mapMarker"
                    (mapClick)="openInfoWindow(floodMarker, 'floodMarker')"
        >
          <map-info-window #floodInfoWindow="mapInfoWindow"
            (closeclick)="hideLotDimensions()">
            <div class="info-window marker-window__message">
              <ng-container *ngFor="let layerData of floodZoneMarker.data">
                <ul class="list-unstyled m-0"
                    *ngIf="layerData">
                  <li *ngIf="layerData.floodZoneCode">
                    <label class="marker-window__label">Flood Zone Code:</label>{{layerData.floodZoneCode}}
                  </li>
                  <li *ngIf="layerData.panelNumber">
                    <label class="marker-window__label">Flood Zone Panel:</label>
                    <span class="text-uppercase">{{layerData.panelNumber}}</span>
                  </li>
                  <li *ngIf="layerData.panelDate">
                    <label class="marker-window__label">Panel Date:</label>{{layerData.panelDate}}
                  </li>
                </ul>
              </ng-container>
            </div>
          </map-info-window>
        </map-marker>
      </ng-container>

      <ng-container *ngIf="trendsLayerMarker$ | async as trendsLayerMarker">
        <map-marker *ngIf="trendsLayerMarker.isOpen"
                    [position]="{ lat: trendsLayerMarker.lat, lng: trendsLayerMarker.lng }"
                    [options]="{ opacity: 0 }"
                    #trendMarker="mapMarker"
                    (mapClick)="openInfoWindow(trendMarker, 'trendMarker')"
        >
        </map-marker>
        <map-info-window #trendInfoWindow="mapInfoWindow" (closeclick)="hideLotDimensions()">
            <div class="info-window marker-window__message">
              <ng-container *ngFor="let layerData of trendsLayerMarker.data">
                <h4 class="mb-2">
                  Trend: {{trendsLayerMarker.layerLabel}}
                </h4>
                <ul class="list-unstyled m-0">
                  <li *ngIf="layerData.timeFrame">
                    <label class="marker-window__label">Duration:</label>
                    {{layerData.timeFrame}}
                  </li>
                  <li *ngIf="layerData.currentDate">
                    <label class="marker-window__label">Current As Of:</label>
                    {{layerData.currentDate}}
                  </li>
                  <li *ngIf="layerData.regionValue">
                    <label class="marker-window__label">Value:</label>
                    {{layerData.regionValue}}
                  </li>
                  <li *ngIf="layerData.typeDescription">
                    <label class="marker-window__label">Area:</label>
                    {{layerData.typeDescription}}
                  </li>
                  <li *ngIf="layerData.propertyType">
                    <label class="marker-window__label">Property Type:</label>
                    {{layerData.propertyType}}
                  </li>
                </ul>
              </ng-container>
            </div>
        </map-info-window>
      </ng-container>

    </google-map>
  </ng-container>

  <rlst-map-controls *ngIf="map"
                     [map]="map"
                     [currentMapTypeId]="currentMapTypeId"
                     [isRotateControlHidden]="isRotateControlHidden"
                     (mapTypeId)="changeMapTypeId($event)"></rlst-map-controls>

  <div class="layers-legend-wrapper" *ngIf="map">
    <mat-expansion-panel *ngIf="driveDirectionWindowIsOpen" class="d-block d-md-none map-legend-panel" [expanded]="true"
                         [hideToggle]="true">
      <mat-expansion-panel-header collapsedHeight="40px" expandedHeight="24px">
        <mat-panel-title>
          <span class="title-message">Driving Directions</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <rlst-drive-direction-window [leg]="driveDirectionLeg"
                                   (closeWindow)="driveDirectionClose()"
                                   (clearDirections)="clearDirections()">
      </rlst-drive-direction-window>
    </mat-expansion-panel>
    <rlst-map-legend></rlst-map-legend>
  </div>

  <div class="trends-hint" *ngIf="mapMessage$ | async as mapMessage">{{mapMessage}}</div>
</section>
